import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ItemForm from './ItemForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditItemModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }

    submitHandler = ( { item } ) => {
        this.setState( { fetching: true } );

        this.props.updateItem( item.id, item )
        .then( ( newItem ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newItem );
        } );
    }

    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }

    deleteItem = () => {
        this.setState( { fetching: true } );
        this.props.deleteItem( this.props.item.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }


    render() {
        const { item } = this.props;
        var initialValues = {
            ...item,
        };

        return (
            <DLModal title='Edit Item'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ItemForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS ITEM?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteItem }>
                            DELETE Item
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS ITEM
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateItem: ( id, data ) => {
            return dAPI.patch( `/admin/homepage/hero/${ id }`, data );
        },
        deleteItem: ( id ) => {
            return dAPI.delete( `/admin/homepage/hero/${ id }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( EditItemModal );
